import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SERVICES, PORTFOLIO_IMAGES } from "../lib/content";

export default function ServicesPage() {
  const [hovered, setHovered] = useState(0);
  return (
    <div data-testid="services-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-28 md:pt-40 pb-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="eyebrow text-[var(--crest-gold)]"
        >— Services</motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="font-serif text-5xl md:text-7xl tracking-tight mt-6 leading-[1.02] max-w-4xl"
        >
          A complete arsenal for the principal ready to lead.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-6 max-w-2xl text-lg text-[var(--crest-muted)]"
        >
          Packages are customized per client following an initial consultation. Below, a survey of the disciplines we orchestrate.
        </motion.p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-7 divide-y divide-black/10 border-y border-black/10">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, delay: (i % 6) * 0.04 }}
              onMouseEnter={() => setHovered(i % PORTFOLIO_IMAGES.length)}
              className="py-7 md:py-9 cursor-default grid md:grid-cols-12 gap-4 group"
              data-testid={`service-row-${s.id}`}
            >
              <div className="md:col-span-7">
                <h3 className="font-serif text-2xl md:text-3xl tracking-tight group-hover:text-[var(--crest-gold)] transition-colors">
                  {s.title}
                </h3>
              </div>
              <div className="md:col-span-5 text-sm text-[var(--crest-muted)] leading-relaxed">{s.description}</div>
            </motion.div>
          ))}
        </div>
        <div className="md:col-span-5 sticky md:top-32 h-fit">
          <div className="aspect-[4/5] overflow-hidden bg-black">
            <img src={PORTFOLIO_IMAGES[hovered]} alt="" className="w-full h-full object-cover luxe-img" />
          </div>
          <div className="mt-8 border border-black/10 p-8">
            <div className="eyebrow text-[var(--crest-gold)]">— Begin Here</div>
            <h4 className="font-serif text-2xl mt-3">Every engagement starts with a consultation.</h4>
            <p className="text-sm text-[var(--crest-muted)] mt-3">Deposit is non-refundable but applied toward your final invoice.</p>
            <Link to="/book" className="btn-primary mt-6 w-full" data-testid="services-cta">Book Consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
